import { api } from '../../../lib';
import { DataItem } from '../../../@types/DataItem';
import { MoreFiltersDataItem } from '../../../reducers/gerenciadorPrecos/filters/moreFilters';
import { paramsArrayRepeat } from '../../../utils/paramsArrayRepeat';

export const moreFiltersData: MoreFiltersDataItem[] = [
  { label: 'Filtro MPDV', value: 'scope' },
  { label: 'Regras de preço', value: 'ruleIds' },
  { label: 'Arquitetura', value: 'architectureIds' },
];

export const listMoreFitersData = async (): Promise<MoreFiltersDataItem[]> => {
  return Promise.resolve(moreFiltersData);
};

export const getMoreFilterDataItem = (value: MoreFiltersDataItem['value']) => moreFiltersData.find(item => item.value === value);

export const listMpdvScopeData = async (search = '') => {
  const response = await api.get<string[]>('/setup/scopes', {
    params: { search },
    expectToken: true,
    paramsSerializer: paramsArrayRepeat,
  });

  return response.data.map(scope => ({ label: scope, value: scope }));
};

export const listArchitectureData = async (search = '', selectedArchitectureIds: string[] = []): Promise<DataItem[]> => {
  const response = await api.get<string[]>('/price-architecture/architecture-ids', { expectToken: true });
  const normalizedSearch = search.trim().toLowerCase();
  const architectureIds = [...new Set(response.data)];
  const selectedArchitectureIdsWithoutDuplicates = [...new Set(selectedArchitectureIds)];
  const filteredArchitectureIds = architectureIds.filter(id => !normalizedSearch || id.toLowerCase().includes(normalizedSearch));
  const filteredValues = new Set(filteredArchitectureIds);
  const availableArchitectureIds = [...filteredArchitectureIds, ...selectedArchitectureIdsWithoutDuplicates.filter(id => !filteredValues.has(id))];

  return availableArchitectureIds.map(id => ({ label: id, value: id }));
};

type ClientRule = {
  ruleId: string;
  ruleName: string;
};

export type ListPriceRulesRequestParams = {
  search?: string;
  ruleIds?: string;
  size: number;
};

const fetchPriceRulesData = async (search = '', ruleIds: string[] = []): Promise<DataItem[]> => {
  const params: ListPriceRulesRequestParams = { search, size: 20 };
  if (ruleIds.length) params.ruleIds = ruleIds.join(',');

  const response = await api.get<ClientRule[]>('/rules/client-rules', {
    params,
    expectToken: true,
  });

  return response.data.map(({ ruleId, ruleName }) => ({ label: ruleName, value: ruleId }));
};

export const listPriceRulesData = async (search = '', selectedRuleIds: string[] = []): Promise<DataItem[]> => {
  const uniqueSelectedRuleIds = [...new Set(selectedRuleIds)];
  const data = await fetchPriceRulesData(search, uniqueSelectedRuleIds);

  if (!uniqueSelectedRuleIds.length) return data;

  const selectedValues = new Set(uniqueSelectedRuleIds);
  return data.filter(item => selectedValues.has(item.value));
};
